import { getAccessToken } from "@/common/util/get-access-token";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Axios 인스턴스 생성
export const baseApi = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  validateStatus: function (status) {
    return status <= 500;
  },
});

baseApi.interceptors.request.use(
  (config) => {
    const accessToken = getAccessToken();
    if (accessToken) {
      config.headers["authorization"] = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    if (error) return Promise.reject(error);
  }
);

baseApi.interceptors.response.use(
  (response) => {
    const ok = response.status < 300;
    response.data = {
      data: response.data,
      ok,
    };
    return response;
  },
  (error) => {
    if (error) return Promise.reject(error);
  }
);
